import { router } from '@/routes/router';
import { useRoute } from 'vue-router';

export function navigateTo(targetRoute, query = {}, state = {}) {
    router.push({
        name: targetRoute,
        query: {
            ...query
        },
        state: {
            ...state
        }
    });
}

export function getRouteParam(param) {
    const route = useRoute();
    return route.params[param];
}

export function getRouteName() {
    const route = useRoute();
    return route.name;
}
